import { Expose, Type } from "class-transformer";
import { IsNumber, IsString, IsOptional, IsBoolean, ValidateNested } from "class-validator";

export class MailContentModel {
  @IsString()
  @Expose()
  mailContent!: string;
  @IsOptional()
  @IsNumber()
  @Expose()
  recordStampId!: number | null;
  @IsString()
  @Expose()
  mailContentKeyDescription!: string;
  @IsBoolean()
  @Expose()
  isExist!: boolean;
  @Type(() => StringKeyValue)
  @ValidateNested()
  @Expose()
  availableTags!: Array<StringKeyValue>;

  constructor() {
    this.mailContent = "";
    this.mailContentKeyDescription = "";
    this.isExist = false;
    this.availableTags = [];
  }
}

export class StringKeyValue {
  @IsString()
  @Expose()
  key!: string;
  @IsString()
  @Expose()
  value!: string;
}
